import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { consultFeeEstimate, consultFeeRetrieve } from 'Redux/modules/webChat/consultFee/actions';

const useConsultFee = consultId => {
  const dispatch = useDispatch();
  const consultFee = useSelector(state => state.webChat.consultFee);

  const getConsultFee = useCallback(() => {
    dispatch(consultFeeRetrieve(consultId));
  }, [consultId, dispatch]);

  const estFee = useCallback(() => {
    dispatch(consultFeeEstimate(consultId, 0));
  }, [consultId, dispatch]);

  return { consultFee, getConsultFee, estFee };
};
export default useConsultFee;
